import { useState } from 'react'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Heading } from '@campgladiator/cgui-core.atoms.typography'
import { GrowlMessage } from '@campgladiator/cgui-core.molecules.growl-message'
import { AddressForm } from 'components/module/address/address-form'
import { postOutdoorAddress } from 'services/api/address'
import { Address } from 'types/address'
import styles from './create.module.scss'

const CreateAddress = () => {
  const [alert, setAlert] = useState({
    open: false,
    title: '',
    text: '',
  })

  const handleAlertClose = () => {
    setAlert({
      open: false,
      title: '',
      text: '',
    })
  }

  const handleSaveAddress = (formData: Address) => {
    return new Promise(async (resolve, reject) => {
      try {
        await postOutdoorAddress(formData)
        setAlert({
          open: true,
          title: 'SUCCESS',
          text: 'Address saved successfully',
        })

        resolve('done')
      } catch (error: any) {
        setAlert({
          open: true,
          title: 'FAILED',
          text: error,
        })

        reject('failed')
      }
    })
  }

  return (
    <Card flat className={styles.container}>
      <header className={styles.header}>
        <Heading className={styles.title} type="h3">
          Create Address
        </Heading>
      </header>
      <div>
        <GrowlMessage
          isVisible={alert.open}
          onClick={handleAlertClose}
          title={alert.title}
        >
          {alert.text}
        </GrowlMessage>
        <AddressForm onSubmitForm={handleSaveAddress} />
      </div>
    </Card>
  )
}

export default CreateAddress
